import { trpc } from "lib/trpc";
import { useIsUserLoggedIn } from "./useIsUserLoggedIn";

export const useCurrentUser = () => {
    const isLoggedIn = useIsUserLoggedIn();

    const { data: user } = trpc.users.me.useQuery(undefined, { enabled: isLoggedIn });

    return user ?? undefined;
};
